import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-7xl sm:text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10 flex flex-col items-center">
        <h1 className="text-lg sm:text-xl md:text-2xl font-semibold mt-6">This page has not been generated</h1>
        <p className="mt-2 text-sm sm:text-base text-gray-400 font-mono break-all max-w-xs sm:max-w-none">{location.pathname}</p>
        <p className="mt-4 text-base sm:text-lg md:text-xl text-gray-500">Tell me more about this page, so I can generate it</p>
        <Link
          to="/"
          className="mt-6 w-full sm:w-auto inline-block px-8 py-3 rounded-full bg-gradient-to-r from-orange-500 to-pink-600 text-white font-bold hover:scale-105 transition-all whitespace-nowrap"
        >
          Go Back Home
        </Link>
      </div>
    </div>
  );
}